import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import MenuButton from "../shared/MenuButton";

interface CreateWorkorderButtonProps {
  onCreateNewWorkOrderClick: () => void;
  onCreateMultiWorkOrderClick: () => void;
}

export default function CreateWorkorderButton(props: CreateWorkorderButtonProps) {
  const { t } = useTranslation();

  const { onCreateNewWorkOrderClick, onCreateMultiWorkOrderClick } = props;

  function handleCreateNewWorkOrderClick() {
    onCreateNewWorkOrderClick();
  }

  function handleCreateMultiWorkOrderClick() {
    onCreateMultiWorkOrderClick();
  }

  return (
    <MenuButton
      variant="button"
      buttonProps={{ startIcon: <AddIcon /> }}
      menuItems={[
        {
          icon: <AddBoxIcon />,
          text: t("workorders.singleWorkOrder"),
          onClick: handleCreateNewWorkOrderClick,
        },
        {
          icon: <LibraryAddIcon />,
          text: t("workorders.multipleWorkOrders"),
          onClick: handleCreateMultiWorkOrderClick,
        },
      ]}
    >
      {t("common.createEntity", { entity: t("workorders.workorder") })}
    </MenuButton>
  );
}
